import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import { topics } from '@/mocks/topics';
import { articles } from '@/mocks/articles';

export default function TopicSection() {
  return (
    <section id="topics" className="px-4 md:px-6 py-12 md:py-16">
      <SectionTitle
        eyebrow="专题策划"
        title="把同一类内幕串成一条线"
        desc="专题把分散的线报按事件逻辑重新编排，方便你一次性补全整段脉络。"
      />
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {topics.map((topic) => {
          const related = articles.filter((a) => topic.articleSlugs.includes(a.slug));
          return (
            <article
              key={topic.id}
              className="group flex flex-col sm:flex-row rounded-lg overflow-hidden border border-background-200/80 bg-background-50 hover:border-primary-300 transition-colors"
            >
              <div className="w-full sm:w-44 h-44 sm:h-auto shrink-0 overflow-hidden">
                <img src={topic.cover} alt={topic.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="flex-1 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
                  {topic.tag}
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{topic.title}</h3>
                <p className="mt-1 text-xs text-primary-700">{topic.subtitle}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{topic.desc}</p>
                <ul className="mt-4 space-y-1.5">
                  {related.map((rel) => (
                    <li key={rel.id}>
                      <Link
                        to={`/article/${rel.slug}`}
                        className="inline-flex items-start gap-1.5 text-xs text-foreground-700 hover:text-primary-600 transition-colors"
                      >
                        <i className="ri-link mt-0.5 text-secondary-600" />
                        <span className="line-clamp-1">{rel.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}